// extracted by mini-css-extract-plugin
export default {"bg":"client_bg__CH9ZN","header":"client_header__Vyirq","clientContent":"client_clientContent__ttyOV"};